<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '车辆租金'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData">
        <section slot="car" slot-scope="prop">
          <ChooseCar
            :otherSearchData="{
              isCheckAuthVehicle: 1,
              licenceType: 3,
            }"
            :isRadio="true"
            v-model="prop.form.car"
            @change="handleCarChange"
          />
        </section>
        <section slot="trailer" slot-scope="prop">
          <ChooseCar
            :otherSearchData="{
              isCheckAuthVehicle: 1,
              licenceTypeEq: 3,
            }"
            :isRadio="true"
            v-model="prop.form.trailer"
            :clearable="true"
          />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import ChooseCar from 'components/choose/car';
export default {
  components: {
    ChooseCar,
  },
  props: {
    serviceInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    serviceInfo (newValue) {
      if (newValue.serviceId) {
        if (this.$refs.customForm) {
          this.$refs.customForm.setVal('serviceName', newValue.serviceName);
        }
      }
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '车牌号码',
            value: 'car',
            slot: true,
            default: {},
          },
          {
            label: '挂车车牌',
            value: 'trailer',
            slot: true,
            default: {},
            // hide: true,
          },
          {
            label: '费用日期',
            value: 'feeAscriptionDate',
            type: 'date',
            default: '',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '费用金额',
            value: 'payAmt',
            type: 'input',
            placeholder: '月租金',
          },
          {
            label: '租期范围',
            value: 'Time',
            placeholder: '请选择租期范围',
            type: 'date',
            width: '240px',
            default: [],
            attr: {
              type: 'daterange',
            },
          },
          // {
          //   label: '租期开始时间',
          //   value: 'tenancyStartDate',
          //   placeholder: '请选择租期开始时间',
          //   type: 'date',
          //   width: '240px',
          //   attr: {
          //     time: '00:00:00',
          //   },
          // },
          // {
          //   label: '租期结束时间',
          //   value: 'tenancyEndDate',
          //   placeholder: '请选择租期结束时间',
          //   type: 'date',
          //   width: '240px',
          //   attr: {
          //     time: '00:00:00',
          //   },
          // },

          {
            label: '租金月份',
            value: 'tenancyMonth',
            type: 'date',
            placeholder: '请选择租金月份',
            attr: {
              type: 'month',
            },
          },
          // {
          //   label: '出租方',
          //   value: 'serviceName',
          //   type: 'input',
          //   disabled: true,
          //   placeholder: '请输入出租方',
          // },
          // {
          //   label: '出租方ID',
          //   value: 'serviceId',
          //   type: 'input',
          //   disabled: true,
          //   placeholder: '请输入出租方ID',
          //   hide: true,
          // },

          {
            label: '费用说明',
            value: 'payRemark',
            type: 'input',
            placeholder: '请输入费用说明',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '上传附件',
            value: 'detailPic',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: { // 表单验证规则
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          payAmt: [ // 申请金额
            { required: true, message: '请输入申请金额', trigger: 'blur' },
          ],
          feeAscriptionDate: [ // 费用日期
            { required: true, message: '请选择费用日期', trigger: 'blur' },
          ],
          Time: [
            { required: true, message: '请选择租期范围', trigger: 'blur' },
          ],
          // tenancyStartDate: [
          //   { required: true, message: '请选择租期开始时间', trigger: 'blur' },
          // ],
          // tenancyEndDate: [
          //   { required: true, message: '请选择租期开始时间', trigger: 'blur' },
          // ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          this.type = 'edit';
          item.car = {
            plateNumber: item.plateNumber,
            licenceType: item.licenceType,
            licenceTypeName: item.licenceTypeName,
          };
          item.trailer = {
            plateNumber: item.trailerNumber,
          };
          item.Time = [item.tenancyStartDate, item.tenancyEndDate];
          this.$refs.customForm.setVal(item);
          this.handleCarChange();
        } else { // 新增
          this.type = 'add';
        }
      });
    },

    handleCarChange () {
      // const car = this.$refs.customForm.getVal('car');
      // this.setFormAttrVal({
      //   form: this.formData,
      //   attr: 'hide',
      //   value: car.licenceType === 1,
      //   names: ['trailer'],
      // });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 车牌号码
      form.plateNumber = form.car.plateNumber;
      form.licenceType = form.car.licenceType;
      form.licenceTypeName = form.car.licenceTypeName;
      delete form.car;
      // 挂车车牌
      form.trailerNumber = form.trailer.plateNumber;
      delete form.trailer;
      // // 租期开始时间
      // form.tenancyStartDate = this.formatDate(form.tenancyStartDate, 1);
      // // 租期结束时间
      // form.tenancyEndDate = this.formatDate(form.tenancyEndDate, 1);
      if (form.Time && form.Time.length) {
        // 租期开始时间
        form.tenancyStartDate = this.formatDate(form.Time[0]);
        // 租期结束时间
        form.tenancyEndDate = this.formatDate(form.Time[1]);
      }
      form.tenancyMonth = this.formatDate(form.tenancyMonth, 3);
      form.feeAscriptionDate = this.formatDate(form.feeAscriptionDate);
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
